import React,{Component} from 'react';

import {Card,CardBody} from 'reactstrap';

import MoneyDisplay from '../../../shared/components/MoneyDisplay';

import moment from 'moment';

import {
  formatDateRange,
  timeForEngagements,
  humanReadableTime,
  costPerCompletion
} from '../../../shared/utils';

class CampaignOverview extends Component {
  render(){
    const { activeCampaign, activeEngagements } = this.props;

    const reachDenominator = costPerCompletion(activeCampaign,activeEngagements),
      reachNumerator = activeCampaign.lifetimeBudget,
      reach = Math.round(reachDenominator > 0 ? reachNumerator/reachDenominator : 0);

    return (
      <Card>
        <CardBody>
          <div>
            <strong>{activeEngagements.length} - activity experience</strong>
          </div>
          <div>
            <strong><MoneyDisplay>{activeCampaign.lifetimeBudget || 0}</MoneyDisplay> budget</strong>
          </div>
          <div>
            <strong>{humanReadableTime(timeForEngagements(activeEngagements))}</strong>
            <br />
            <small className="text-muted">Estimated time spent per consumer</small>
          </div>
          <div>
            <strong>{(isNaN(reach) ? 0 : reach).toLocaleString()} consumers</strong>
            <br />
            <small className="text-muted">Reach</small>
          </div>
          {(moment(activeCampaign.launchDate).isValid() && moment(activeCampaign.endDate).isValid()) && (
            <strong>
              {formatDateRange(activeCampaign.launchDate,activeCampaign.endDate,'to')}
            </strong>
          )}
          {(activeCampaign.launchDate && moment(activeCampaign.launchDate).isValid() && (!activeCampaign.endDate)) && (
            <strong>
              Starts {formatDateRange(activeCampaign.launchDate)}
            </strong>
          )}
        </CardBody>
      </Card>
    )
  }
}

export default CampaignOverview



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignOverview.js